/* L'aggancio React alla skin: il componente si ridisegna quando la skin
   cambia. Succede una volta all'avvio e, in anteprima, a ogni ritocco nel
   backoffice. Restituisce la skin corrente.
   Si ridisegna anche quando lo schermo passa da computer a telefono (o
   viceversa): una parte puo' essere accesa su uno e spenta sull'altro
   (leggi.js, perDispositivo). */
import React from 'react';
import {skinCorrente, ascoltaSkin} from '../skin';
import {osservaSchermo} from '../components/SportMenu/sport-central/schermo';
import {ascolta} from '../preferenze';

export function useSkin() {
  const [, ridisegna] = React.useState(0);
  React.useEffect(() => ascoltaSkin(() => ridisegna((n) => n + 1)), []);
  React.useEffect(() => osservaSchermo(() => ridisegna((n) => n + 1)), []);
  /* e quando cambia la lingua: i testi della skin hanno le loro traduzioni (leggi.js, nellaLingua) */
  React.useEffect(() => ascolta(() => ridisegna((n) => n + 1)), []);
  return skinCorrente();
}
